import { combineEpics } from 'redux-observable'
import checkoutTechnicalErrorEpic from './checkoutTechnicalError'
import classicStartAddToCartEpic from './classicStartAddToCart'
import clickBackToHomepage from './clickBackToHomepage'
import clickCancellationPoliciesEpic from './clickCancellationPolicies'
import clickConfiguratorSelectionChangeEpic from './clickConfiguratorSelectionChange'
import clickMapPinTrackingEpic from './clickMapPin'
import clickPersonnalizeYourTripEpic from './clickPersonnalizeYourTrip'
import clickProductCardTabEpic from './clickProductCardTab'
import clickProductBulletpointsEpic from './clickProductBulletpoints'
import clickProductThumbnailEpic from './clickProductThumbnail'
import clickSearchButtonEpic from './clickSearchButton'
import clickReviewsClickScoreTrackingEpic from './clickReviewsClickScore'
import clickReviewsCloseTrackingEpic from './clickReviewsClose'
import clickReviewsOpenTrackingEpic from './clickReviewsOpen'
import clickSelectFormulaEpic from './clickSelectFormula'
import clickSelectTechnicalSheetTabEpic from './clickSelectTechnicalSheetTab'
import clickShowMapTrackingEpic from './clickShowMap'
import clickToggleCheapestPrice from './clickToggleCheapestPrice'
import clickTransportationPillsTrackingEpic from './clickTransportationPills'
import clickUniverseThumbnailEpic from './clickUniverseThumbnail'
import clickValidationEpic from './clickValidation'
import disableOnPreviewProductionEpic from './disableOnPreviewProduction'
import filterCatalogEpic from './filterCatalog'
import filtersViewFilteredCatalogEpic from './filtersViewFilteredCatalog'
import initMixpanelEpic from './init'
import memberErrorEpic from './memberError'
import navigateProductSlideshowEpic from './navigateProductSlideshow'
import redirectionModalEpic from './redirectionModal'
import registerEpic from './register'
import rejectionModalEpic from './rejectionModal'
import saleChangeEpic from './saleChange'
// import scrollSectionConsumptionEpic from './scrollSectionConsumption'
import startClientRedirectionEpic from './startClientRedirection'
import technicalErrorEpic from './technichalError'
import technicalErrorNoPackageEpic from './technicalErrorNoPackage'
import tooltipEventEpic from './tooltipEvent'
import trackPerformancesEpic from './trackPerformances'
import viewCatalogPageEpic from './viewCatalogPage'
import viewedProductEpic from './viewedProduct'
import viewProductPageEpic from './viewProductPage'
import viewSaleHomePageEpic from './viewSaleHomePage'

export default combineEpics(
  disableOnPreviewProductionEpic,
  initMixpanelEpic,
  registerEpic,
  checkoutTechnicalErrorEpic,
  trackPerformancesEpic,
  saleChangeEpic,
  classicStartAddToCartEpic,
  clickBackToHomepage,
  clickCancellationPoliciesEpic,
  clickToggleCheapestPrice,
  clickConfiguratorSelectionChangeEpic,
  clickMapPinTrackingEpic,
  clickPersonnalizeYourTripEpic,
  clickProductBulletpointsEpic,
  clickProductCardTabEpic,
  clickProductThumbnailEpic,
  clickSelectFormulaEpic,
  clickSearchButtonEpic,
  clickReviewsCloseTrackingEpic,
  clickReviewsOpenTrackingEpic,
  clickReviewsClickScoreTrackingEpic,
  clickSelectTechnicalSheetTabEpic,
  clickShowMapTrackingEpic,
  clickTransportationPillsTrackingEpic,
  clickUniverseThumbnailEpic,
  clickValidationEpic,
  filterCatalogEpic,
  filtersViewFilteredCatalogEpic,
  memberErrorEpic,
  navigateProductSlideshowEpic,
  redirectionModalEpic,
  rejectionModalEpic,
  // scrollSectionConsumptionEpic,
  startClientRedirectionEpic,
  tooltipEventEpic,
  technicalErrorEpic,
  technicalErrorNoPackageEpic,
  viewCatalogPageEpic,
  viewProductPageEpic,
  viewSaleHomePageEpic,
  viewedProductEpic
)
